import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  handleReplace: () => void;
  handleAppend: () => void;
}

export function PropertyImagePrefillDialog({ isOpen, handleClose, handleReplace, handleAppend }: Props) {
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Property images</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This offer already has images. Would you like to replace them with the property images or add them to the
          existing ones?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="text" onClick={handleAppend}>
          Add to existing
        </Button>
        <Button variant="contained" onClick={handleReplace}>
          Replace
        </Button>
      </DialogActions>
    </Dialog>
  );
}
